import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import copyIcon from '@/assets/icons/copy.svg';
import doneIcon from '@/assets/icons/done.svg';
import styles from './CopyButton.module.css';

interface CopyButtonProps {
  value: string;
  className?: string;
}

const CopyButton = ({ value, className }: CopyButtonProps) => {
  const { t } = useTranslation();
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    await navigator.clipboard.writeText(value);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <button
      type="button"
      className={`${styles.button} ${className ?? ''}`.trim()}
      onClick={copy}
      aria-label={copied ? t('donations.admin.copied') : t('donations.admin.copy')}
      title={copied ? t('donations.admin.copied') : t('donations.admin.copy')}
    >
      <img src={copied ? doneIcon : copyIcon} alt="" className={styles.icon} />
    </button>
  );
};

export default CopyButton;
